import React, {useEffect, useState} from 'react';
import s from "./styles.module.css";
import TableElement from "../../components/table_element";
import {Tooltip} from "@mui/material";
import classNames from "classnames";
import {red} from "@mui/material/colors";

const Row = ({
                 isFirstElement,
                 time,
                 part,
                 number,
                 base_mark,
                 row1,
                 row2_name,
                 row1_name,
                 row2,
                 statusColored,
                 subDataStatus,
                 difficulty_code,
                 isHidden = false,
                 bonus,
                 type,
                 id,
                 handlerClick
             }) => {
    // const [typeValue, setType] = useState(type)

    return (
        <div className={s.row}>
            <TableElement width={110}>{time}</TableElement>
            <TableElement left={20} width={104}>{part}</TableElement>
            <TableElement left={20} width={46}>{+number}</TableElement>
            {/*<TableElement left={20} width={104}>{base_mark}</TableElement>*/}
            <TableElement className={s.big_text} showTooltip={true} left={20}
                          width={251}>{difficulty_code}</TableElement>
            <TableElement showTooltip={true} left={20} width={134}>{bonus}</TableElement>
            {(statusColored && !isHidden) && <>
                <div style={{
                    backgroundColor:
                        row1?.value === 1 && '#86B760' ||
                        row1?.value === 2 && '#E9695E' ||
                        row1?.value === 3 && '#EBC810'
                }} className={classNames(s.colored_box, s.row_1)}>
                    <span>{row1_name}</span>
                </div>
                <div style={{
                    backgroundColor:
                        row2?.value === 1 && '#86B760' ||
                        row2?.value === 2 && '#E9695E' ||
                        row2?.value === 3 && '#EBC810'
                }} className={classNames(s.colored_box, s.row_1)}>
                    <span>{row2_name}</span>
                </div>
            </>}

            <div style={{
                backgroundColor: type === 2 && '#E9695E'
            }} onClick={() => {
                handlerClick(id, 2)
            }}
                 className={classNames(s.colored_box, isFirstElement && s.red_box)}></div>
            <div style={{
                backgroundColor: type === 3 && '#EBC810'
            }} onClick={() => {
                handlerClick(id, 3)
            }} className={classNames(s.colored_box, isFirstElement && s.yellow_box)}></div>
            <div style={{
                backgroundColor: type === 1 && '#86B760'
            }} onClick={() => {
                handlerClick(id, 1)
            }} className={classNames(s.colored_box, isFirstElement && s.green_box)}></div>
        </div>
    );
};

export default Row;
